export const fa: Record<string, string> = {
  "app.title": "اسناد",
  "app.subtitle": "قراردادها بر اساس ماده",
  "settings.language": "زبان",
  "settings.theme": "پوسته",

  "common.loading": "در حال بارگذاری…",
  "common.close": "بستن",
  "common.back": "بازگشت",
  "common.error": "خطا",
  "common.retry": "تلاش دوباره",

  "access.title": "دسترسی محدود است",
  "access.body": "این برنامه را از طریق بات تلگرام با دعوت‌نامهٔ مدیر باز کنید.",

  "docs.empty": "هنوز سندی بارگذاری نشده است.",
  "docs.count": "{n} ماده",
  "docs.pages": "صفحه",

  "doc.search": "جستجوی مواد…",
  "doc.expand_all": "باز کردن همه",
  "doc.collapse_all": "بستن همه",
  "doc.download_title": "دانلود کل سند",
  "doc.no_results": "چیزی یافت نشد",
  "doc.results": "یافت شد: {n}",

  "clause.open": "باز کردن",
  "clause.download": "دانلود ماده",
  "clause.speak": "شنیدن",
  "clause.stop": "توقف",
  "fmt.word": "Word",
  "fmt.pdf": "PDF",

  "download.fail": "دانلود فایل ناموفق بود",
  "download.preparing": "در حال آماده‌سازی فایل…",

  "share.button": "اشتراک‌گذاری",
  "share.download": "دانلود",
  "share.format": "فرمت",
  "share.fail": "اشتراک‌گذاری ناموفق بود",
  "share.downloaded": "فایل دانلود شد",

  "tabs.documents": "اسناد",
  "tabs.letters": "مکتوب‌ها",
  "tabs.users": "کاربران",

  "letters.title": "مکتوب‌ها",
  "letters.subtitle": "مکتوب‌ها و گزارش‌های رسمی",
  "letters.empty": "هنوز مکتوبی وجود ندارد.",
  "letters.doc_date": "مکتوب",
  "letters.added": "اضافه شد",

  "users.title": "کاربران و دسترسی",
  "users.invite_heading": "دعوت کاربر",
  "users.name_placeholder": "نام و نام خانوادگی",
  "users.make_admin": "دسترسی مدیر",
  "users.create": "ساخت لینک دعوت",
  "users.creating": "در حال ساخت…",
  "users.link_ready": "لینک یک‌بارمصرف (۱۴ روز اعتبار):",
  "users.copy": "کپی",
  "users.copied": "کپی شد ✓",
  "users.share": "اشتراک‌گذاری",
  "users.share_text": "دعوت به برنامهٔ «اسناد»",
  "users.list_heading": "کاربران",
  "users.role.admin": "مدیر",
  "users.role.reader": "خواننده",
  "users.active": "فعال",
  "users.inactive": "غیرفعال",
  "users.deactivate": "غیرفعال‌سازی",
  "users.activate": "فعال‌سازی",
  "users.empty": "هنوز کاربری وجود ندارد.",
  "users.invite_fail": "ساخت دعوت‌نامه ناموفق بود",
  "users.you": "شما",

  "tabs.files": "فایل‌ها",
  "files.title": "فایل‌ها و پوشه‌ها",
  "files.new_folder": "پوشهٔ جدید",
  "files.folder_name": "نام پوشه",
  "files.create": "ساختن",
  "files.empty_folders": "هنوز پوشه‌ای وجود ندارد.",
  "files.empty_files": "این پوشه خالی است.",
  "files.upload": "بارگذاری فایل",
  "files.uploading": "در حال بارگذاری…",
  "files.download": "دانلود",
  "files.view": "مشاهده",
  "files.delete": "حذف",
  "files.confirm_del_folder": "پوشه و همهٔ فایل‌هایش حذف شود؟",
  "files.confirm_del_file": "این فایل حذف شود؟",
  "files.count": "{n} فایل",
};
